
import { ajax, getRequestUrl, formatData } from "../request";
export default {
  getBotTextList(data, method) {
    return ajax('post', getRequestUrl('/room/bot/text/list'), data, {
      method,
    });
  },
  saveBotText(data, method) {
    return ajax('post', getRequestUrl('/room/bot/text/save'), data, {
      method,
    });
  },
  batchDelBotText(data, method) {
    return ajax('post', getRequestUrl('/room/bot/text/batchDel'), data, {
      method,
    });
  },
  ///room/bot/image/list
  getBotImageList(data, method) {
    return ajax('post', getRequestUrl('/room/bot/image/list'), data, {
      method,
    });
  },
  ///room/bot/image/save
  saveBotImage(data, method) {
    return ajax('post', getRequestUrl('/room/bot/image/save'), data, {
      method,
    });
  },
  ///room/bot/image/batchDel
  batchDelBotImage(data, method) {
    return ajax('post', getRequestUrl('/room/bot/image/batchDel'), data, {
      method,
    });
  },
  // 话题库审核列表
  getBotTitleList(data, method) {
    return ajax('post', getRequestUrl('/room/bot/title/list'), data, {
      method,
    });
  },
  // 话题库审核
  batchReviewTitle(data, method) {
    return ajax('post', getRequestUrl('/room/bot/title/review'), data, {
      method,
    });
  },
  //设置提交黑名单
  setBotBlackList(data, method) {
    return ajax('post', getRequestUrl('/room/bot/title_black/set'), data, {
      method,
    });
  },
  // 图片库审核列表
  getImgTitleList(data, method) {
    return ajax('post', getRequestUrl('/room/bot/title_image/list'), data, {
      method,
    });
  },
  // 图片库审核
  batchReviewTitleImage(data, method) {
    return ajax('post', getRequestUrl('/room/bot/title_image/review'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/roomBot.js